module.exports = __webpack_public_path__ + "img/tbzj.d30d4889.png";